<script setup>
import { onBeforeMount, onMounted, toRaw, toRef, computed, watch, ref } from "vue";
import env from "@/helpers/Environment";
import _ from "lodash";
import { useRouter, useRoute } from 'vue-router'
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import { useStoreSite } from '@/stores/store.site';

const route = useRoute()
const storeSite = useStoreSite();

const router = useRouter()
const stageEnv = env.STAGE_ENV;
const cTitle = computed(() => toRaw(storeSite.title));
const cSiteLayout = computed(() => toRaw(storeSite.layoutView));
const cIsMobile = computed(() => storeSite.isMobile);
const cIsNoneLayout = computed(() => storeSite.layout == 'none');

let runOnceOnChangeFlag = false;
const debounceResizeWindow = _.debounce(() => {
      let flag = storeSite.checkIsMobile();
      if (runOnceOnChangeFlag != flag) {
        runOnceOnChangeFlag = flag;
        if (flag) {
          storeSite.resetFlag("mobile");
        } else {
          storeSite.resetFlag("screen");
        }
      }
    }, 100);
window.addEventListener("resize", debounceResizeWindow);
debounceResizeWindow();


onBeforeMount(async () => {
  document.title = "";
});


</script>

<template>
  

<div class="ribbon" v-if="stageEnv != 'prod' && !cIsNoneLayout">{{stageEnv}}</div>

<Toast />

<DynamicDialog />

<ConfirmDialog></ConfirmDialog>


<teleport to="head title">{{ cTitle }}</teleport>

<div :class="['wrapper', cIsMobile?'mobile':'']">
<!-- {{store.state.site.mobile}} -->
  <component :is="cSiteLayout" />
</div>
<iframe id="iframe-session" :src="`${env.OIDC_URL}/check-session`" style="display:none"></iframe>
</template>


<style lang="scss">

.confirmDialog-custom {
  width: 300px;
}

@media screen and (min-width:820px) {
  .confirmDialog-custom {
    width: 500px;
  }
}

@media screen and (min-width:$break-large) {
  .confirmDialog-custom {
    width: 450px;
  }
}


.debug {
  color: red;
  position:absolute;
  width:800px;
  top: 50px;
}

.wrapper {
  width: 100%;
  height: 100%;
}
</style>